import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TabService {

  tabs: { title: string, icon: string, path: string }[] = [];

  addTab(title: string, icon: string, path: string) {
    if (!this.tabs.find(tab => tab.path === path)) {
      if (this.tabs.length >= 6) {
        this.tabs.shift(); // elimina la más antigua (primer elemento)
      }
      this.tabs.push({title, icon, path});
    }
  }

  closeTab(path: string) {
    this.tabs = this.tabs.filter(tab => tab.path !== path);
  }

  getTabs() {
    return this.tabs;
  }

  clearTabs() {
    this.tabs = [];
  }
}
